import { render, staticRenderFns } from "./TransactionEditModalProvider.vue?vue&type=template&id=d15b07ce&"
import script from "./TransactionEditModalProvider.vue?vue&type=script&lang=js&"
export * from "./TransactionEditModalProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports